import { render, staticRenderFns } from "./fun_step.vue?vue&type=template&id=88cf1bf2&scoped=true&"
import script from "./fun_step.vue?vue&type=script&lang=js&"
export * from "./fun_step.vue?vue&type=script&lang=js&"
import style0 from "./fun_step.vue?vue&type=style&index=0&id=88cf1bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cf1bf2",
  null
  
)

export default component.exports